import { render, staticRenderFns } from "./MenuI18n.vue?vue&type=template&id=60f2a907&scoped=true"
import script from "./MenuI18n.vue?vue&type=script&lang=js"
export * from "./MenuI18n.vue?vue&type=script&lang=js"
import style0 from "./MenuI18n.vue?vue&type=style&index=0&id=60f2a907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f2a907",
  null
  
)

export default component.exports